import React from 'react';
interface LogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}

// "African Pulse" — a bespoke F monogram with flowing lines suggesting
// connection and momentum, with a discreet geometric reference to Africa
// through the negative space of the mark.
export function Logo({
  variant = 'dark',
  className = ''
}: LogoProps) {
  const primary = variant === 'light' ? '#F8F7F4' : '#0F172A';
  const gold = '#D4AF37';
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-101" data-mp="mtdwyr2wl3d2">
      <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Flicker Africa monogram" className="shrink-0" data-id="element-102" data-mp="rsh0u875d3jg">
        {/* Flowing pulse lines suggesting momentum */}
        <path d="M6 30 C 16 22, 24 34, 34 24 C 40 18, 42 20, 44 18" stroke={gold} strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.9" data-id="element-103" data-mp="2yhvn9dqw72ov" />
        {/* Bespoke F monogram */}
        <path d="M14 12 H34 V17 H20 V22 H31 V27 H20 V38 H14 Z" fill={primary} data-id="element-104" data-mp="1ex42822ogds6" />
      </svg>
      <div className="leading-none" data-id="element-105" data-mp="1nvprsh6kgt2g">
        <span className="block font-serif text-xl tracking-wide" style={{
        color: primary
      }} data-id="element-106" data-mp="1nwr40ozbjllr">
          Flicker
        </span>
        <span className="block text-[10px] font-medium tracking-widest uppercase" style={{
        color: gold
      }} data-id="element-107" data-mp="1jwgwv8zsip5b">
          Africa
        </span>
      </div>
    </div>;
}